import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './ProviderRequestInfo.html';
import { Inject } from 'vue-di-container';
import ProviderRequestsService from '../ProviderRequestsService';
import { ProviderRequestAttachment, ProviderRequestsModel } from '../ProviderRequestsModel';
import FileSaver from 'file-saver';
import { ProviderAttachmentCategoryType } from '@/shared/Enums/ProviderAttachmentCategoryType';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ProviderRequestsService,
    ],
})
export default class ProviderRequestInfo extends Vue {
    @Inject(ProviderRequestsService) public providerRequestsService!: ProviderRequestsService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ default: '' })
    public id!: string;


    public providerRequest: ProviderRequestsModel = {} as ProviderRequestsModel;


    public created() {
        this.$emit('childinit', this.layoutSup);
    }

    async mounted() {
        this.providerRequest = await this.providerRequestsService.GeById(this.id);
        if (!this.providerRequest.providerRequestAttachments) {
            (this.providerRequest as any).providerRequestAttachments = [];
        }
    }

    public async DownloadAttachment(att: ProviderRequestAttachment) {
        try {
            const base64 = att.fileContent || '';
            const bytes = Buffer.from(base64, 'base64');
            const mime = this.guessMime(att.fileName);
            const blob = new Blob([bytes], { type: mime });
            FileSaver.saveAs(blob, att.fileName || 'attachment');
        } catch (e) {
                const bytes = Buffer.from(att.fileContent || '', 'base64');
                const blob = new Blob([bytes]);
                FileSaver.saveAs(blob, att.fileName || 'attachment');
        }
    }

    private guessMime(name: string | undefined | null) {
        const ext = String(name || '').split('.').pop()!.toLowerCase();
        if (ext === 'pdf') return 'application/pdf';
        if (ext === 'docx') return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        if (ext === 'doc') return 'application/msword';
        return 'application/octet-stream';
    }
    public GetProviderRequestStatus(typeStatus: number) {
        typeStatus = typeStatus;
        switch (typeStatus) {
            case 1: {
                return 'Pending Approval';
                break;
            }
            case 2: {
                return 'Approved';
                break;
            }
            case 3: {
                return 'Rejected';
                break;
            }
        }
    }

    public labelFor(id: string) {
        const ZERO = '00000000-0000-0000-0000-000000000000';
        const map: Record<string, string> = {
            [ProviderAttachmentCategoryType.CstLicense]: this.$t('shared.cstLicense').toString(),
            [ProviderAttachmentCategoryType.CommercialRegistration]: this.$t('shared.commercialRegistration').toString(),
            [ProviderAttachmentCategoryType.DelegationLetter]: this.$t('shared.delegationLetter').toString(),
            [ProviderAttachmentCategoryType.NationalAddress]: this.$t('shared.nationalAddress').toString(),
            [ProviderAttachmentCategoryType.ZakatTaxCertificate]: this.$t('shared.zakatTaxCertificate').toString(),
        };
        const key = (id || '').toLowerCase();
        if (key === ZERO) {
            return this.$t('shared.delegationLetter').toString();
        }
        return map[id] || id;
    }
}
